import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TENDERO_ENDPOINTS } from '../../shared/models/Constants';
import {
    DEFAULT_DATA,
    DEFAULT_GENERAL_DATA_BY_ID,
    DEFAULT_MOVEMENT, IRCCPGeneralDataById, IRCCPGeneralDataByIdResp,
    IRCPPRespGeneralData,
    IRCPPRespMovement,
    MAPA_PILAR
} from '../../shared/models/recompepsi.interface';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorGetGeneralData,
    errorGetGeneralDataById,
    errorGetMovements,
    getGeneralData,
    getGeneralDataById,
    getMovements,
    successGetGeneralData,
    successGetGeneralDataById,
    successGetMovements
} from '../actions';

@Injectable()
export class RecompepsiEffects {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    /**
     * * Obtiene datos generales del programa de lealtad
     */
    public getGeneralData$ = createEffect(
        () => this.actions$.pipe(
            ofType(getGeneralData),
            switchMap(
                () => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_general_data, {})
                    .pipe(
                        map((resp: IRCPPRespGeneralData) => successGetGeneralData(!resp.data || typeof resp.data === 'string' ? DEFAULT_DATA : resp.data)),
                        catchError((err: Error) => of(errorGetGeneralData({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Obtiene datos generales del programa de lealtad por id
     */
    public getGeneralDataById$ = createEffect(
        () => this.actions$.pipe(
            ofType(getGeneralDataById),
            switchMap(
                actions => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_general_data, actions)
                    .pipe(
                        map((resp: IRCCPGeneralDataByIdResp) => successGetGeneralDataById(this.notFoundById(resp, actions.idPilar))),
                        catchError((err: Error) => of(errorGetGeneralDataById({ payload: err })))
                    )
            )
        )
    );

    /**
     * Maneja el caso cuando no se encuentra el pilar solicitado
     * @param resp Respuesta de la API
     * @param idPilar ID del pilar solicitado
     * @returns Información del pilar
     */
    private notFoundById = (resp: IRCCPGeneralDataByIdResp, idPilar: number): IRCCPGeneralDataById => {
        const pilarKey = MAPA_PILAR[idPilar];

        const defaultById: IRCCPGeneralDataById = {
            cliente: DEFAULT_GENERAL_DATA_BY_ID.cliente,
            metadata: DEFAULT_GENERAL_DATA_BY_ID.metadata,
            ...(pilarKey ? { [pilarKey]: DEFAULT_GENERAL_DATA_BY_ID[pilarKey] } : {})
        } as IRCCPGeneralDataById;

        if (!resp || !resp.data || typeof resp.data === 'string') {
            return defaultById;
        }

        const exists = pilarKey && resp.data[pilarKey] !== undefined && resp.data[pilarKey] !== null;
        return exists ? resp.data : defaultById;
    };

    /**
     * * Obtiene movimientos del programa de lealtad
     */
    public getMovements$ = createEffect(
        () => this.actions$.pipe(
            ofType(getMovements),
            switchMap(
                actions => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_movements, actions)
                    .pipe(
                        map((resp: IRCPPRespMovement) => successGetMovements(typeof resp.data === 'string' ? DEFAULT_MOVEMENT : resp.data)),
                        catchError((err: Error) => of(errorGetMovements({ payload: err })))
                    )
            )
        )
    );
}
